import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import UserLogin from './pages/user-login';
import ReportOutage from './pages/report-outage';
import GeographicOutageMap from './pages/geographic-outage-map';
import ServiceOutageDetails from './pages/service-outage-details';
import UserRegistration from './pages/user-registration';
import OutageDashboard from './pages/outage-dashboard';
import ServiceProviderProfile from './pages/service-provider-profile';
import UserProfileSettings from './pages/user-profile-settings';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<OutageDashboard />} />
        <Route path="/user-login" element={<UserLogin />} />
        <Route path="/report-outage" element={<ReportOutage />} />
        <Route path="/geographic-outage-map" element={<GeographicOutageMap />} />
        <Route path="/service-outage-details" element={<ServiceOutageDetails />} />
        <Route path="/user-registration" element={<UserRegistration />} />
        <Route path="/outage-dashboard" element={<OutageDashboard />} />
        <Route path="/service-provider-profile" element={<ServiceProviderProfile />} />
        <Route path="/user-profile-settings" element={<UserProfileSettings />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;